import Invoice, { InvoiceDto } from "../models/invoice"
import HttpClient from "../../helpers/HttpClient"
import {HttpError, isError} from "../../helpers/Error"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { PatchPayload } from "../../pricing/services"

class Service {
    httpClient: HttpClient<Invoice, InvoiceDto> = new HttpClient<Invoice, InvoiceDto>(Invoice)

    async get(id: string) {
        return this.httpClient.get("/invoices/" + id)
    }

    async applyBulkDiscount(id: string, payload: object){
        return this.httpClient.put(`/invoices/${id}/bulk-discount`, payload)
    }

    async applyBulkUpdate(id: string, payload: object){
        return this.httpClient.patch(`/invoices/${id}/bulk-update`, payload)
    }

    async getInvoice(id: string): Promise<Invoice | HttpError> {
        const res = await this.httpClient.get(`/invoices/${id}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Invoice
    }

    async patch(id: string, payload: PatchPayload) {
        return AppContext.getApiClient().patch(`/invoices/${id}`, payload)
    }
}

export const InvoiceService = new Service()



// WEBPACK FOOTER //
// ./src/state/invoice/services/service.ts